import React, { useState } from "react";
import { GET_LIST, Toolbar, SaveButton, NumberInput } from "react-admin";
import { Card } from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import moment from "moment";
import styled from "styled-components";
import moment_tz from 'moment-timezone';
import {
  map,
  curry,
  range,
  filter,
  prop, 
  propEq,
  isNil
} from "ramda";
import {
  TextInput
} from "react-admin";
import LinearProgress from "@material-ui/core/LinearProgress";
import FormControl from "@material-ui/core/FormControl";
import CustomDatePicker from "./customDatePicker";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import CustomDatePickerYM from "./CustomDatePickerYM";
import ReactExport from 'react-data-export';

import { API_ROOT } from "../api-config";

const styles = {
  container: {
    marginLeft: "0em",
    textAlign: "center",
  },
  rightAlignedCell: { textAlign: "right" },
  leftAlignedCell: { textAlign: "left" },
  centerAlignedCell: { textAlign: "center" },
  title: { backgroundColor: "#ff9800" },
  blackBold: { fontWeight: "bold", color: "black" },
  boldCell: { fontWeight: "bold" },
  widthTable: {
    marginLeft: "30px",
    width: "50%"
  },
  flex: { display: "flex" },
};

let dataSetAll = [];
let dataSetRentals = [];
let dataSetTours = [];
let dataSetToursGuided = [];
let dataSetOld = [];
let yearsArray = [];
let locationJson = null;

const StartForm = styled.div({
  margin: "30px",
  display: "flex",
  flexDirection: "column",
  width: "30%",
  //   height: "29rem",
  justifyContent: "space-between"
});

const useStyles = styled.div({
  backgroundColor: "transparent"
});
class reportSales extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      numberOfMonths: 2,
      yearsStart: 2016,
      locationsArray: null,
      yearsEnd: moment()
        .startOf("year")
        .format("YYYYMMDD"),
      optDateBegin: null,
      optDateEnd: null,
      loading: false,
      showTables: false,
      setLoading: false,
      exportData: [],
      setExportData: [],
      DataSet: [],
      month: moment()
        .startOf("month")
        .format("YYYYMMDD")
    };
  }

  async componentDidMount() {
    moment_tz.tz.setDefault("Europe/Madrid");
    const startDate = moment().format("YYYYMMDD");
    const endDate = moment().format("YYYYMMDD");
    await this.updateState(startDate, endDate, null, null, null);

  }

  updateState = async (
    startDate,
    endDate,
    optDateBegin,
    optDateEnd
  ) => {
    const numberOfMonths = moment(endDate).diff(moment(startDate), "months");
    this.setState({
      numberOfMonths,
      isLoading: false,
      startDate,
      endDate,
      month: moment(startDate).format("YYYYMMDD"),
      optDateBegin,
      optDateEnd
    });
  };

  sortedDayList = (start, end) => {
    const add = (day, offset) => day.clone().add(offset, "days");
    return map(curry(add)(start), range(0, end.diff(start, "days") + 1));
  };

  handleChangeOptE = eventDate => {
    if (eventDate < this.state.optDateBegin) {
      
    } else {
      const startYear = moment(this.state.optDateBegin).year();
      const endYear = moment(eventDate).year();
      if (startYear != endYear) {

      } else {
        this.setState({ optDateEnd: eventDate });
      }
    }
  };

  handleChangeOptB = eventDate => {
    this.setState({
      optDateBegin: eventDate
    });
  };

  handleDateTimeChange = (event, fieldName) => {
    // eslint-disable-next-line no-underscore-dangle
    if (!isNil(event)) {
      this.setState({ [fieldName]: event });
    }
  };

  handleChange = () => {
    dataSetRentals = [];
    dataSetTours = [];
    dataSetToursGuided = [];
    dataSetOld = [];
    if (this.state.optDateBegin !== null && this.state.optDateEnd !== null &&
      this.state.optDateBegin !== '' && this.state.optDateEnd !== '') {
      this.setState({ exportData: [], loading: true, showTables: true });
      this.getReports();
    }
  };

  async getReports() {
    const eventDateStart = moment(this.state.optDateBegin._d).format('YYYY-MM-DD');
    const eventDateEnd = moment(this.state.optDateEnd._d).format('YYYY-MM-DD');
    const dataProvider = await dataProviderFactory("rest");
    const reportSales = dataProvider(GET_LIST, "reports/reportSales", {
      filter: {
        startDate: eventDateStart,
        endDate: eventDateEnd,
      },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    reportSales.then(async (result) => {
      this.state.loading = false;
      dataSetRentals = result.data;
      dataSetAll = result.data;
      dataSetTours = result.data.tours;
      dataSetToursGuided = result.data.selfGuided;
      dataSetOld = result.data;
      const tipoT = dataSetOld.filter(r => r.type === 'T');
      const tipoR = dataSetOld.filter(r => r.type === 'R');
      dataSetRentals = tipoR
      dataSetTours = tipoT
     
      // Obtenemos una lista de todos los años disponibles
      yearsArray = Array.from(new Set(dataSetRentals.map(item => item.years)));
    
      const dataSet = [{
        columns: [
          { title: "Year", style: { font: { sz: "14", bold: true }, fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } } }, width: { wpx: 125 } }, // width in pixels
          { title: "Location", style: { font: { sz: "14", bold: true }, fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } } }, width: { wpx: 125 } }, // width in pixels
          { title: "Total", style: { font: { sz: "14", bold: true }, fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } } }, width: { wpx: 200 } }, // width in pixels                    
        ],
        data: dataSetRentals.map((data) => [
          { value: (data.years != null) ? new Intl.NumberFormat().format(data.years) : '', style: { font: { sz: "12" } } },
          { value: (data.location != null) ? data.location : '', style: { font: { sz: "12" } } },
          { value: (data.total != null) ? data.total : '', style: { font: { sz: "12" } } }
        ])
      }];

      this.setState({ loading: false, exportData: tipoR, DataSet: dataSet });
      return result.data;
    })
      .catch((error) => {
        this.state.loading = false;
      });


  }

  async fetchLocations() {
    const dataProvider = await dataProviderFactory("rest");
    const locations = await dataProvider(GET_LIST, "locations", {
      filter: { only_bases: "true" },
      pagination: {
        page: 1,
        perPage: 50
      },
      sort: { field: 'id', order: "DESC" }
    });

    const baseLocations = filter(location => {
      return isNil(location.base_location_id) && !propEq("location_name", "Other", location);
    }, locations.data);
    locationJson = baseLocations
    this.setState({ locations: baseLocations });
  }

  async getReportsDownload(startDate, endDate) {

    let data = {
      startDate: startDate,
      endDate: endDate
    };

    const response = await fetch(`${API_ROOT}/reports/download`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.token}`,
      },
      body: JSON.stringify(data)
    });

    let commits = await response.json(); // read response body and parse as JSON

    let a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    // a.href = 'data:' + registro.mimeType + ';base64,' + registro.base64;
    a.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${commits.data}`;
    a.download = `Metrics.xlsx`;
    a.click();
    a.remove();
  }

  render() {
    const {
      isLoading,
      month,
      optDateBegin,
      optDateEnd,
    } = this.state;

    const { classes, ...props } = this.props;

    if (isLoading) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }

    function getColorByLocation(localidad, objetos) {
      // Verificar si objetos es un arreglo y no está vacío
      if (Array.isArray(objetos) && objetos.length > 0) {
        for (let i = 0; i < objetos.length; i++) {
          if (objetos[i].location_name === localidad) {
            return objetos[i].color;
          }
        }
      }
      return null; // Si no se encuentra la localidad o el arreglo es vacío, devolvemos null
    }

    const totalsByLocationAndYear = {};
    dataSetRentals.forEach(item => {
      totalsByLocationAndYear[item.location] = totalsByLocationAndYear[item.location] || {};
      totalsByLocationAndYear[item.location][item.color] = getColorByLocation(item.location, this.locationsArray)
      totalsByLocationAndYear[item.location][item.years] = new Intl.NumberFormat().format(Number(item.total).toFixed(2));
    });

    const startDate = moment(this.state.optDateBegin).format("DD-MMM");
    const endDate = moment(this.state.optDateEnd).format("DD-MMM");

    const PostCreateToolbar = props => 
      <Toolbar {...props} style={{ backgroundColor: 'transparent' }}>
        <SaveButton label="Generate" type="submit" onClick={this.handleChange} />
      </Toolbar>;
    const salesByYear = {};
    dataSetAll.forEach(item => {
      if (!salesByYear[item.years]) {
        salesByYear[item.years] = { rentals: 0, tours: 0, selfguidedIMT: 0, guideIMT:0, guidedP4M: 0, selfGuidedP4M: 0, totalG: 0, totalSG: 0 };
      }
      if (item.type === 'R') {
        salesByYear[item.years].rentals += item.total;
      } else if (item.type === 'T') {
        salesByYear[item.years].tours += item.total;
        salesByYear[item.years].selfguidedIMT += item.selfguidedIMT;
        salesByYear[item.years].guideIMT += item.guideIMT;
        salesByYear[item.years].guidedP4M += item.guidedP4M;
        salesByYear[item.years].selfGuidedP4M += item.selfGuidedP4M;
        salesByYear[item.years].totalG += item.guideIMT;
        salesByYear[item.years].totalG += item.guidedP4M;
        salesByYear[item.years].totalSG += item.selfguidedIMT;
        salesByYear[item.years].totalSG += item.selfGuidedP4M;
      }

    });
    return (
      <Card>
        <StartForm>
          <h3>Sales Report By Range</h3>
          <div style={{display:'flex', flexDirection:'row', margin:'20px'}}>
            <div >
              <FormControl style={{ marginBottom: '10px', marginRight: '10px'}}>
                <CustomDatePicker 
                  onChange={e => this.handleChangeOptB(e)}
                  minDate={'2022-01-01'}
                  selectedDate={
                  optDateBegin && optDateBegin !== "null"
                      ? moment(optDateBegin).format("YYYY-MM-DD")
                      : null
                  }
                  label="Date Begin"
                /> 
              </FormControl>
              
              <FormControl style={{ marginBottom: '10px', marginLeft: '10px'}}>
                <CustomDatePicker
                  onChange={e => this.handleChangeOptE(e)}
                  minDate={'2022-01-01'}
                  selectedDate={
                  optDateEnd && optDateEnd !== "null"
                    ? moment(optDateEnd).format("YYYY-MM-DD")
                    : null
                  }
                  label="Date End"
                />  
              </FormControl>
            </div>
          </div>
          <PostCreateToolbar />
        </StartForm>
        {this.state.showTables ? (
          <div style={styles.flex}>
            <Table style={styles.widthTable}>
              <TableHead>
                <TableRow >
                  <TableCell colSpan={3} style={styles.centerAlignedCell}>
                    <h3>TOURS ({startDate} to {endDate})</h3>
                  </TableCell>
                </TableRow>
                <TableRow style={styles.title}>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>Years</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>G. IMT</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>G. P4M</TableCell>                  
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>SG. IMT</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>SG. P4M</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>Total G.</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>Total SG.</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>Rentals</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>Years Totals</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(salesByYear).map(year => (
                  <TableRow key={year}>
                    <TableCell style={styles.centerAlignedCell}>
                      {year}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {new Intl.NumberFormat().format(salesByYear[year].guideIMT)}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {new Intl.NumberFormat().format(salesByYear[year].guidedP4M)}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {new Intl.NumberFormat().format(salesByYear[year].selfguidedIMT)}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {new Intl.NumberFormat().format(salesByYear[year].selfGuidedP4M)}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {new Intl.NumberFormat().format(salesByYear[year].totalG)}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {new Intl.NumberFormat().format(salesByYear[year].totalSG)}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {new Intl.NumberFormat().format(salesByYear[year].rentals)}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      {new Intl.NumberFormat().format(salesByYear[year].rentals + salesByYear[year].totalSG + salesByYear[year].totalG)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        ) : null}
        {this.state.showTables ? (
          <div style={styles.flex}>
            <div style={styles.flex}>
              <Table style={styles.widthTable}>
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={3} style={styles.centerAlignedCell}>
                      <h3>RENTALS ({startDate} to {endDate})</h3>
                    </TableCell>
                  </TableRow>
                  <TableRow style={styles.title}>
                    <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>Location</TableCell>
                    {yearsArray.map(year => (
                      <TableCell key={year} style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>{year}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.keys(totalsByLocationAndYear).map(location => (
                    <TableRow key={location}>
                      <TableCell key={location} id={location} style={{ backgroundColor: getColorByLocation(location, locationJson) }}>
                        {location}
                      </TableCell>
                      {yearsArray.map(year => (
                        <TableCell key={year} style={styles.centerAlignedCell}>

                          {totalsByLocationAndYear[location][year] || 0}

                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </div>
        ) : null}
        <div style={{ marginBottom: '10px'}}></div>
      </Card>
    );
  }
}

export default reportSales;


// WEBPACK FOOTER //
// ./src/components/reportSales.js